import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Table } from "@themesberg/react-bootstrap";
import { ReactComponent as IconDelete } from "../../../assets/icons/icon-delete.svg";
import { InputNumber, Select } from "antd";
import { useEditing } from "../../../hook/EdittingContext";
export const TableEquipment = forwardRef(
  (
    {
      pageEquipments,
      setPageEquipments,
      lstEquimentCbb,
      isValidEquiment,
      setIsValidEquipment,
    },
    ref
  ) => {
    const { isEditing, setIsEditing } = useEditing();

    // Hàm xóa dòng
    const handleDelete = (index) => {
      const newPageEquipments = [...pageEquipments];
      newPageEquipments.splice(index, 1);
      setPageEquipments(newPageEquipments);
      setIsEditing(true);
    };

    const handleOnChange = (value, index) => {
      const newPageEquipments = [...pageEquipments];
      newPageEquipments[index].amount = value;
      setPageEquipments(newPageEquipments);
      setIsEditing(true);
    };

    function isNumericString(str) {
      if (str !== "1,000") {
        return /^-?\d+(\.\d+)?$/.test(str);
      }
      return true;
    }
    // Xử lý khi nhập tiếng Nhật (IME)
    const handleCompositionEnd = (e, index) => {
      let value = e.target.value.replace(/[^0-9]/g, ""); // Chỉ giữ số
      if (!isNumericString(e.target.value)) {
        value = 1;
        e.target.value = 1;
      } else {
        value = parseFloat(value); // Giới hạn từ 1 - 1000
        if (value > 1000) {
          value = 1000;
          e.target.value = "1,000";
        } else {
          e.target.value = value;
        }
      }

      const newPageEquipments = [...pageEquipments];
      newPageEquipments[index].amount = value;
      setPageEquipments(newPageEquipments);
    };

    const handleOnBlur = (e, index) => {
      let value;

      if (!isNumericString(e.target.value)) {
        value = 1;
      } else {
        value = parseFloat(e.target.value || 1);
      }

      if (e.target.value === "1,000") {
        value = 1000;
      }
      if (value > 1000) {
        value = 1000;
      }
      const newPageEquipments = [...pageEquipments];
      if (value <= 0) {
        newPageEquipments[index].amount = 1;
      } else {
        newPageEquipments[index].amount = value;
      }
      setPageEquipments(newPageEquipments);
      setIsEditing(true);
    };

    const handleSaveEquipment = (value, index) => {
      const newPageEquipments = [...pageEquipments];
      newPageEquipments[index].equipment = value;
      setPageEquipments(newPageEquipments);
      setIsValidEquipment(true);
      setIsEditing(true);
    };

    const handleKeyPress = (event) => {
      const inputElement = event.target;
      const charCode = event.which ? event.which : event.keyCode;
      const newChar = String.fromCharCode(charCode);
      const cursorPosition = inputElement.selectionStart;
      const inputValue = event.target.value;

      // Tạo giá trị sau khi thêm ký tự mới vào
      const updatedValue =
        inputValue == "0"
          ? newChar
          : inputValue.slice(0, cursorPosition) +
            newChar +
            inputValue.slice(cursorPosition);
      const validInput = updatedValue.replace(/[,]/g, ""); // Loại bỏ dấu phẩy và dấu chấm để tính số ký tự hợp lệ

      // Kiểm tra nếu giá trị nhập vào vượt quá 1000
      if (parseFloat(validInput) > 1000 && charCode !== 8) {
        // 8 là mã của phím backspace
        event.preventDefault();
        return;
      }

      // Cho phép các phím từ 0 đến 9, phím điều khiển (backspace), dấu chấm
      if (
        (charCode >= 48 && charCode <= 57) || // Số từ 0-9
        charCode === 46 || // Dấu chấm
        charCode === 8 // Backspace
      ) {
        const [integerPart, decimalPart] = validInput.split(".");

        // Chỉ cho phép một dấu chấm
        if (charCode === 46 && inputValue.includes(".")) {
          event.preventDefault();
          return;
        }

        // Kiểm tra số chữ số sau dấu thập phân (chỉ được 1 chữ số)
        if (decimalPart && decimalPart.length > 3) {
          event.preventDefault();
          return;
        }

        // Kiểm tra số nguyên không vượt quá 1000 (tức là không được nhập vượt quá 1000)
        if (integerPart && parseInt(integerPart) > 1000) {
          event.preventDefault();
          return;
        }
      } else {
        // Chặn các ký tự không phải số, dấu chấm
        event.preventDefault();
      }
    };

    const formatValue = (value) => {
      // Định dạng phần nguyên với dấu phẩy
      const formattedIntegerPart = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedIntegerPart;
    };

    const getOptionsForIndex = (index) => {
      const selectedEquipments = pageEquipments
        .filter((_, i) => i !== index)
        .map((item) => item.equipment);

      return lstEquimentCbb.filter(
        (option) => !selectedEquipments.includes(option.value)
      );
    };

    return (
      <Table
        responsive
        className="tabel table-centered table-nowrap rounded mb-0"
      >
        <thead className="thead-light">
          <tr>
            <th style={{ width: "50px" }}>#</th>
            <th>Equipment</th>
            <th style={{ width: "144px" }}>Amount</th>
            <th style={{ width: "47px" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {pageEquipments.map((item, index) => (
            <tr>
              <td>{index + 1}</td>
              <td>
                <Select
                  className="w-100"
                  value={item.equipment}
                  onChange={(value) => handleSaveEquipment(value, index)}
                  showSearch
                  options={getOptionsForIndex(index)}
                  placeholder="Select Equipment"
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                />
                {index === 0 && !isValidEquiment && (
                  <div style={{ color: "red", marginTop: "5px" }}>
                    {"Equipment is required field"}
                  </div>
                )}
              </td>
              <td>
                <InputNumber
                  value={item.amount}
                  onChange={(value) => handleOnChange(value, index)}
                  max={1000}
                  formatter={formatValue}
                  onKeyPress={handleKeyPress}
                  onCopy={(e) => e.preventDefault()} // Chặn sao chép
                  onPaste={(e) => e.preventDefault()} // Chặn dán
                  onCut={(e) => e.preventDefault()}
                  onBlur={(e) => handleOnBlur(e, index)}
                  parser={(value) => value.replace(/,/g, "").replace(/，/g, "")} // Xử lý dấu phân cách Nhật
                  onCompositionEnd={(e) => handleCompositionEnd(e, index)}
                  // onCompositionUpdate={(e) => {
                  //   if (!/^\d*$/.test(e.data)) {
                  //     e.preventDefault();
                  //   }
                  // }}
                />
              </td>
              <td>
                <div className="delete" onClick={() => handleDelete(index)}>
                  <IconDelete />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }
);
